import {RT_TRD_GROUP_SET} from "../../../function/GroupDataModel";
import { LogD } from "../../../function/LogLapper";

export type SelectDataType = {
  mesid: number;
  devid: number;
  itemid: number;
  selectDate: Date;
  selectTime: string;
  isSelect: boolean;
  isShow: boolean;
}


export type MeasureInfoType = {
  AiCard: number;
  AiCh: number;
  DevIndex: number;
  DevName: string;
  DevNo: string;
  EntryNo: number;
  ItemName: string;
  ItemNameNo: number;
  KindNo: number;
  LogStart: string;
  MesName: string;
  PlcNo : number;
  FftInvalid : number;

  SetNo: number;
  Speed: number;
  selectDay: string;
  selectTime: string;
  name: string;
  id: number;
};

export type LineInfo = {
    FileName: string;
    MaxValue: number;
    MinValue: number;
    YaxisOffset: number;
    XaxisStartIndex: number;
    XaxisSpanCount: number;
    SamplingRate: number;
    XValues: number[];
  YValues: number[];
  UnitSymbol: string;
  ItemName: string;
}

export type RawWaveComparisonData = {
    OneLineData: LineInfo;
    TowLineData: LineInfo;
    YaxisMax: number;
    YaxisMin: number;
    XaxisMax: number;
    XaxisMin: number;
}


export const GetMeasureInfoType = () : Promise<MeasureInfoType[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/MeasuleInfo")
    .then((res) => res.json())
      .then((result: MeasureInfoType[]) => {
        console.debug(result);
        if (MeasureInfoTypeListValidate(result)) resolve(result);
        reject('Invalidate response');
    },
      (error) => {
        console.log(error);
        reject(error);
      }
  );
  });
};

const MeasureInfoTypeListValidate = (data: MeasureInfoType[]) => {
    LogD(`MeasureInfoTypeTypeListValidate ckeck ${data}`,true);
    if (data == undefined) return false;
      LogD("MeasureInfoTypeTypeListValidate ckeck ok",true);
    return true;
  };


export const GetDataTimeList = (plcNo: number, aiNo: number, chNo: number ,targetDay : string ): Promise<string[]> => {
  console.debug("GetDataTimeList exec");
  const url = `api/RawWaveComparison/GetDataTimeList?plcNo=${plcNo}&&aiCardNo=${aiNo}&&channelNo=${chNo}&&targetTime=${targetDay}`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
    .then((res) => res.json())
      .then((result: string[]) => {
        console.debug(result);
        if (DataTimeListValidate(result)) resolve(result);
        reject('Invalidate response');
    },
      (error) => {
        console.log(error);
        reject(error);
      }
  );
  });
};
const DataTimeListValidate = (data: string[]) => {
    LogD(`DataTimeListValidate ckeck ${data}`,true);
    if (data == undefined) return false;
      LogD("DataTimeListValidate ckeck ok",true);
    return true;
};

//CSVファイルの存在する時間リストを取得
export const GetLatesTime = (plcNo? : number, aiCardNo? : number , channelNo? : number) : Promise<string> => {
  return new Promise((resolve, reject) => {
    const url = `api/RawWaveComparison/GetDataLatestTime?plcNo=${plcNo}&&aiCardNo=${aiCardNo}&&channelNo=${channelNo}`;
    console.debug(url);
    fetch(url)
     .then((res) => res.json())
      .then((result: string) => {
        console.debug(result);
        if (LatesTimeValidate(result)) resolve(result);
        reject('Invalidate response');
    },
      (error) => {
        console.log(error);
        reject(error);
      }
  );
  });
};

const LatesTimeValidate = (data: string) => {
    console.debug("LatesTimeValidate ckeck");
    if (data == undefined) return false;
      LogD("LatesTimeValidate ckeck ok",true);
    return true;
};




export const GetGraphLineData = (
  plcNo1: number, aiNo1: number, chNo1: number, targetDay1: string,
  plcNo2: number, aiNo2: number, chNo2: number, targetDay2: string): Promise<RawWaveComparisonData> => {
  console.debug("GetDataTimeList exec");
  const url = `api/RawWaveComparison/GetGraphLineData?plcNo1=${plcNo1}&&aiCardNo1=${aiNo1}&&channelNo1=${chNo1}&&targetTime1=${targetDay1}&&plcNo2=${plcNo2}&aiCardNo2=${aiNo2}&&channelNo2=${chNo2}&&targetTime2=${targetDay2}`;
  //const param1 = `?plcNo1=${plcNo1}&aiCardNo1=${aiNo1}&channelNo1=${chNo1}&targetTime1=${targetDay1}`;
  //const param2 = `&plcNo2=${plcNo2}&aiCardNo2=${aiNo2}&channelNo2=${chNo2}&targetTime2=${targetDay2}`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
    .then((res) => res.json())
      .then((result: RawWaveComparisonData) => {
        console.debug(result);
        if (GraphLineDataValidate(result)) resolve(result);
        reject('Invalidate response');
    },
      (error) => {
        console.log(error);
        reject(error);
      }
  );
  });
};
const GraphLineDataValidate = (data: RawWaveComparisonData) => {
    LogD(`GraphLineDataValidate ckeck ${data}`,true);
    if (data == undefined) return false;
      LogD("GraphLineDataValidate ckeck ok",true);
    return true;
};


/**
 *MeasureInfoTypeのリストより、選択データのデータのMeasureInfoTypeを見つける
 * @param measureInfos　measureInfoリスト
 * @param selectData　選択データ
 * @returns
 */
export const FindMeasureInfo = (measureInfos: MeasureInfoType[], selectData: SelectDataType): MeasureInfoType | undefined => {
  var mes = measureInfos.find((item) => item.id === selectData.mesid);
  var dev = measureInfos.find((item) => item.id === selectData.devid);
  var itm = measureInfos.find((item) => item.id === selectData.itemid);
  var target = measureInfos.find((item) =>
      item.KindNo === mes?.KindNo
      && item.DevIndex === dev?.DevIndex
      && item.ItemNameNo === itm?.ItemNameNo
  );
  return target;
};
